// footer toggle
if (window.matchMedia('(max-width: 799px)').matches) {
    $('.c-footer-block__title').click(function () {
        var block = $(this).parent('.c-footer-block');
        $(block).toggleClass('c-footer-block--is-active');
    });
}

document.addEventListener('DOMContentLoaded', function () {
  let likedProducts = JSON.parse(localStorage.getItem('likedProducts')) || [];

  function updateLikeButton(button, isLiked) {
    const heartIcon = button.querySelector('.heart-icon');
    if (isLiked) {
      heartIcon.classList.add('liked'); // Add the 'liked' class to the heart icon
    } else {
      heartIcon.classList.remove('liked'); // Remove the 'liked' class from the heart icon
    }
  }

  function updateLikedCount() {
    const likedCount = document.getElementById('liked-count');
    const secondaryHeader = document.querySelector('.secondary-header');
    const unlikeAllButton = document.getElementById('unlike-all');

    if (likedCount) {
      likedCount.textContent = likedProducts.length;
      secondaryHeader.style.display = likedProducts.length > 0 ? 'block' : 'none';
      unlikeAllButton.style.display = likedProducts.length > 0 ? 'inline-block' : 'none';
    }
  }

  // On page load, check for liked products and update the buttons
  function initializeLikedButtons() {
    let likeButtons = document.querySelectorAll('.like-btn');
    likeButtons.forEach(button => {
      const productHandle = button.getAttribute('data-product-handle');
      const isLiked = likedProducts.includes(productHandle); // Check if product is in likedProducts
      updateLikeButton(button, isLiked); // Update button appearance
    });
  }

  // Event delegation - add click event listener to the document
  document.addEventListener('click', function (event) {
    if (event.target.closest('.like-btn')) { // Check if the clicked target is within the .like-btn class
      const button = event.target.closest('.like-btn');
      const productHandle = button.getAttribute('data-product-handle');

      // Toggle the liked state
      if (!likedProducts.includes(productHandle)) {
        likedProducts.push(productHandle); // Add product to liked list
      } else {
        likedProducts = likedProducts.filter(handle => handle !== productHandle); // Remove product from liked list
      }

      localStorage.setItem('likedProducts', JSON.stringify(likedProducts)); // Update local storage
      updateLikeButton(button, likedProducts.includes(productHandle)); // Update button appearance
      updateLikedCount(); // Update liked count
    }
  });

  document.getElementById('unlike-all').addEventListener('click', function () {
    likedProducts = []; // Clear the liked products array
    localStorage.setItem('likedProducts', JSON.stringify(likedProducts)); // Update localStorage
    updateLikedCount(); // Update the count and visibility
    const likeButtons = document.querySelectorAll('.like-btn');
    likeButtons.forEach(button => updateLikeButton(button, false)); // Update all buttons to "Like"
    location.reload(); // Refresh the current page
  });

  // Initialize the liked products count on page load
  updateLikedCount();
  initializeLikedButtons(); // Call this function to update the buttons' state on page load

  // Check for dynamically loaded content at intervals (recommendations section)
  const checkRecommendationsInterval = setInterval(function() {
    const recommendedSection = document.querySelector('.product-recommendations');
    if (recommendedSection && recommendedSection.querySelectorAll('.like-btn').length > 0) {
      clearInterval(checkRecommendationsInterval); // Stop checking once recommendations are loaded
      initializeLikedButtons(); // Reinitialize buttons when new products are loaded
    }
  }, 500); // Check every 500ms
});


document.addEventListener('DOMContentLoaded', function() {
  const secondaryHeader = document.querySelector('.secondary-header');
  const headerWrapper = document.querySelector('.header-wrapper'); // Select the header-wrapper element
  let lastScrollTop = 0; // Variable to keep track of last scroll position

  // Function to update the position of the secondary header
  function updateSecondaryHeaderPosition() {
    const headerWrapperHeight = headerWrapper ? headerWrapper.offsetHeight : 0;
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // If the user scrolls down past the header-wrapper height
    if (currentScrollTop > headerWrapperHeight) {
      secondaryHeader.style.top = '0'; // Fix it at the top of the viewport
    } else {
      secondaryHeader.style.top = `${headerWrapperHeight}px`; // Position it below the header-wrapper
    }

    lastScrollTop = currentScrollTop; // Update last scroll position
  }

  // Call the function on page load and on scroll
  updateSecondaryHeaderPosition();
  window.addEventListener('scroll', updateSecondaryHeaderPosition);
  window.addEventListener('resize', updateSecondaryHeaderPosition);
});
